
module.exports.internetConnectionSuspended = 'action.sales.internetConnectionSuspended';
module.exports.internetConnectionDisconnected = 'action.sales.internetConnectionDisconnected';

module.exports.passport = 'action.passport';
module.exports.expirePassport = 'action.passport.expiry';
module.exports.staffLogin = 'action.staff.login';
module.exports.currentStorefront = 'action.storefronts.current';
module.exports.todaysSalesUpdatedTime = 'action.todaysSales.updatedTime';
module.exports.saleContext = 'action.sale.context';
module.exports.cashFloat = 'action.cashFloat';
module.exports.snooze = 'action.snooze';
module.exports.userNotifications = 'action.userNotifications';


module.exports.uiAlert = 'action.ui.alert.dialogue';
module.exports.uiPrompt = 'action.ui.prompt.dialogue';
module.exports.uiLayoutCurrentPageIndex = 'action.ui.layout.current.page.index';
module.exports.uiSettingsChangeTimestamp = 'action.ui.settings.change.timestamp';
module.exports.uiLoginDialogue = 'action.ui.login.dialogue';
module.exports.uiNavigationDialogue = 'action.ui.navigation.dialogue';
module.exports.uiNavigationPage = 'action.ui.navigation.page';
module.exports.uiTillStatus = 'action.ui.till.status';
module.exports.uiOnScreenKeyboard = 'action.ui.screen.keyboard';
module.exports.uiLoadingRunningLate = 'action.ui.loading.running.late';
module.exports.snooze = 'action.snooze';
module.exports.screenSaver = 'action.ui.screen.saver';
